export default function Section1() {
  return (
    <div className="w-full bg-white Section1 py-[30px] md:py-[50px]">

      {/* Main Page Heading */}
      

      {/* Hero Content */}
      <div className="w-[90%] md:w-[85%] mx-auto flex flex-col md:flex-row items-center justify-between gap-10">

        {/* Left Content */}
        <div className="w-full  text-center md:text-left">
          <h2 className="text-center text-[26px] md:text-[30px] font-bold text-[#DA2128] -mt-10 md:mt-0 leading-[34px] mb-6">
           Web Development Agency in New York Creating High-Performing Sites
          </h2>

          <p className="text-center text-[15px] md:text-[18px] text-[#444444] leading-[26px] mb-10  mx-auto md:mx-0">
            Mean3 provides expert web development services for businesses across New York. Our team creates fast, scalable, and user-friendly websites that engage visitors and drive conversions. From startups to established brands, we focus on structured development, intuitive design, and reliable performance. Every website we deliver supports growth, SEO optimization, and seamless user experiences across devices, helping your business strengthen its online presence and achieve long-term success.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center ">
            <a
              href="https://mean3.com/contact-mean3"
              className="bg-[#DA2128] hover:bg-[#b71c22] text-white text-[14px] md:text-[16px] font-semibold px-6 py-3 rounded-[8px] transition-all duration-300"
            >
              Get a Free Consultation
            </a>

            <a
              href="https://mean3.com/contact-mean3"
              className="border border-[#DA2128] text-[#DA2128] hover:bg-[#DA2128] hover:text-white text-[14px] md:text-[16px] font-semibold px-6 py-3 rounded-[8px] transition-all duration-300"
            >
              View Our Work
            </a>
          </div>
        </div>

        {/* Right Image */}
        
      </div>




    </div>
  );
}
